__webpack_require__.p = "https://s3-gz01.didistatic.com/freight-web-v3/freight-open-micro-base/20260511150341/";